// extracted by mini-css-extract-plugin
export default {"wrapper":"nothing-found_wrapper__YvhJY","opacity-transition":"nothing-found_opacity-transition__qasxh"};